export class TicketConversationScrollController {
  private shouldStickToBottom = true;
  private pendingScroll: ReturnType<typeof setTimeout> | null = null;

  constructor(private readonly scrollToBottom: () => void) {}

  messagesChanged(): void {
    if (!this.shouldStickToBottom) return;
    this.schedule(false);
  }

  contentSizeChanged(): void {
    this.messagesChanged();
  }

  positionChanged(shouldStickToBottom: boolean): void {
    this.shouldStickToBottom = shouldStickToBottom;
  }

  forceToBottom(): void {
    this.shouldStickToBottom = true;
    this.schedule(true);
  }

  reset(): void {
    this.cancel();
    this.shouldStickToBottom = true;
  }

  private schedule(force: boolean): void {
    this.cancel();
    this.pendingScroll = setTimeout(() => {
      this.pendingScroll = null;
      if (force || this.shouldStickToBottom) this.scrollToBottom();
    });
  }

  private cancel(): void {
    if (this.pendingScroll === null) return;
    clearTimeout(this.pendingScroll);
    this.pendingScroll = null;
  }
}
